import { render } from "./OrderListTable.vue?vue&type=template&id=1a490c61&scoped=true"
import script from "./OrderListTable.vue?vue&type=script&lang=js"
export * from "./OrderListTable.vue?vue&type=script&lang=js"

import "./OrderListTable.vue?vue&type=style&index=0&id=1a490c61&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a490c61"]])

export default __exports__